import React from 'react';
// @ts-ignore
export default React.createContext();
//# sourceMappingURL=SnackbarContext.js.map